var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.test === 'B')?_c('promo-bar-b'):(_vm.test === 'C')?_c('promo-bar-c'):(_vm.test === 'D')?_c('promo-bar-d'):(_vm.test === 'E')?_c('promo-bar-e'):(_vm.test === 'F')?_c('promo-bar-f'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }